<script setup>
import ReloadPrompt from './service-worker/ReloadPrompt.vue'
</script>

<template>
  <VitePwaManifest />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <RiseToast v-model="$toastItems" class="z-30" />
  <ReloadPrompt />
</template>
